import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "image",
    "counter"
  ]

  static values = {
    images: Array,
    divisions: Number
  }

  connect() {
    this.currentIndex = -1

    this.handleMove =
      this.handleMove.bind(this)

    // preload/cache
    this.preloadImages()

    // estado inicial
    this.updateCounter(0)

    window.addEventListener(
      "mousemove",
      this.handleMove
    )
  }

  disconnect() {
    window.removeEventListener(
      "mousemove",
      this.handleMove
    )
  }

  preloadImages() {
    this.preloadedImages = []

    this.imagesValue.forEach((src, index) => {
      setTimeout(() => {
        const img = new Image()

        img.src = src
        img.decoding = "async"

        this.preloadedImages.push(img)
      }, index * 15)
    })
  }

  handleMove(event) {
    const mouseX = event.clientX
    const screenWidth = window.innerWidth

    const divisionWidth =
      screenWidth / this.divisionsValue

    const divisionIndex = Math.floor(
      mouseX / divisionWidth
    )

    const ratio =
      divisionIndex /
      (this.divisionsValue - 1)

    const imageIndex = Math.floor(
      ratio *
      (this.imagesValue.length - 1)
    )

    const clampedIndex = Math.max(
      0,
      Math.min(
        this.imagesValue.length - 1,
        imageIndex
      )
    )

    if (clampedIndex === this.currentIndex)
      return

    this.currentIndex = clampedIndex

    this.imageTarget.src =
      this.imagesValue[this.currentIndex]

    this.updateCounter(
      this.currentIndex
    )
  }

  updateCounter(index) {
    this.counterTarget.textContent =
      index + 1
  }
}